import SeamlessReconciliationList from './seamless-reconciliation.list';
import SeamlessReconciliationShow from './seamless-reconciliation.show';

export default {
  list: SeamlessReconciliationList,
  show: SeamlessReconciliationShow,
};
